import { useEffect, useRef, useState } from 'react'
import { IconTruckDelivery } from '@tabler/icons-react'

import { DeliverySlotTimer, useDisplayCart } from 'modules/cart'
import { DeliveryArea } from 'modules/content'
import { DeliveryAreaSummary } from 'modules/delivery'
import { Popover } from 'shared/ui/Popover'

import styles from './DeliveryDropdown.module.scss'

const deliveryAreaTexts = {
  infoBox: <p>Kolejne miasta i województwa już wkrótce!</p>,
  header: 'Dostawa Twoich zakupów online',
  description: (
    <p>
      Dostawy z naszego supermarketu online realizujemy na terenie całej Polski.
    </p>
  ),
  image: {
    src: '/static/delivery_map.webp',
    alt: 'Dostarczamy na terenie całej Polski'
  },
  form: {
    title: 'Chcesz upewnić się, czy zakupy dowozimy także do Ciebie?',
    inputLabel: 'Kod pocztowy',
    checkButton: 'Sprawdź',
    setPostalCodeButton: 'Ustaw',
    successMessage: 'Obsługujemy wybrany obszar.',
    errorMessage: 'Jeszcze nie obsługujemy wybranego obszaru.',
    reportMissingPostalCode: 'Zgłoś nam swój kod.'
  }
}

interface DeliveryDropdownProps {
  openPostalCode: boolean
}

const DeliveryDropdown = ({ openPostalCode }: DeliveryDropdownProps) => {
  const anchorRef = useRef<HTMLButtonElement | null>(null)
  const [open, setOpen] = useState(false)
  const cart = useDisplayCart()

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  useEffect(() => {
    if (!openPostalCode) setOpen(false)
  }, [openPostalCode])

  return (
    <>
      <button
        className={styles.wrapper}
        ref={anchorRef}
        onClick={handleOpen}
        aria-label='Dostawa'
        aria-haspopup='true'
        aria-controls='profile-menu'
        aria-expanded={open}
      >
        <IconTruckDelivery />
        <div className={styles.tabletContent}>Dostawa</div>
      </button>
      <Popover
        id='profile-menu'
        anchorEl={anchorRef}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <div className={styles.menuContent} tabIndex={-1}>
          <div className={styles.popupHeader} tabIndex={-1}>
            <div className={styles.title}>Dostawa</div>
          </div>
          <div className={styles.contentWrapper} tabIndex={-1}>
            {cart && (
              <DeliveryAreaSummary>
                <DeliveryArea savePostalCode={true} texts={deliveryAreaTexts} />
              </DeliveryAreaSummary>
            )}
            <DeliverySlotTimer closeMobileModal={() => handleClose()} />
          </div>
        </div>
      </Popover>
    </>
  )
}

export default DeliveryDropdown
